import { render, staticRenderFns } from "./SortIcon.vue?vue&type=template&id=17e96fd1"
import script from "./SortIcon.vue?vue&type=script&lang=ts"
export * from "./SortIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports